import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from 'infrastructure/common/model/api.query';
import { userNotes } from 'user/model/iam-user-note.fragments';
import { UserNoteOutput } from 'user/model/user-note.output';

export interface OwnedUserNotesParams {
	readonly userId: string;
}

@Injectable({ providedIn: 'root' })
export class OwnedUserNotesApiQuery extends ApiQuery<
	UserNoteOutput[],
	OwnedUserNotesParams
> {
	client = 'iam';
	document = gql`
		query OwnedUserNotes($userId: UUID!) {
			ownedUserNotes(userId: $userId) {
				...UserNotes
			}
		}
		${userNotes}
	`;
	method = 'ownedUserNotes';
}
